module.exports = __webpack_public_path__ + "img/certificate1.5fc15805.png";